module.exports = __webpack_public_path__ + "img/kh1.6cedc9f0.png";